// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__kxNyE","tab":"Tabs_tab__N36Ov","active":"Tabs_active__6kMCC"};